module.exports = __webpack_public_path__ + "img/icons8-autumn-50.2d1bd9bc.svg";